



























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { searchUser } from '@/apps/open/services/user'
import { addAdmin } from '@/apps/open/services/admin'
import Avatar from '@/apps/open/components/Avatar'
import Button from '@/apps/open/components/Button'
import { onRequestError } from '@/apps/open/utils'
import store from '@/apps/open/store'

@Component({
  components: {
    Avatar,
    Button
  }
})
export default class AddAdminDialogBody extends Vue {
  @Prop()
  onCancel!: Function

  @Prop()
  onOk!: Function

  selectedUsers: any = []
  searchData: any = {}

  form = {
    keyword: ''
  }

  rules = {
    keyword: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value && !/^\d+$/.test(value)) {
            return callback(new Error('请输入用户ID'))
          } else {
            return callback()
          }
        }
      }
    ]
  }

  get isPrivate () {
    return store.getters['isPrivate']
  }

  get curEnterprise () {
    return store.getters['User/curEnterprise']
  }

  get adminList () {
    return store.getters['Admin/adminList']
  }

  @Watch('form.keyword')
  onKeywordChange (newValue: string) {
    this.searchData = {}
  }

  resetSearchData () {
    this.form.keyword = ''
    this.searchData = {}
  }

  onSearch () {
    const el: any = this.$refs['form']
    el.validate(async (valid: any) => {
      if (valid) {
        try {
          const res = await searchUser(parseInt(this.form.keyword), 'user', this.curEnterprise.developer_id)
          const data = res.data
          this.searchData = {
            ...data.object,
            exists: data.result === 'AlreadyExisted' || this.exists(data.userid)
          }
        } catch (error) {
          onRequestError(error)
        }
      }
    })
  }

  onUserCheck (item: any) {
    this.selectedUsers.unshift(item)
    this.searchData = {}
    this.form.keyword = ''
  }

  exists (userid: number) {
    return [...this.adminList, ...this.selectedUsers].some((item: any) => item.userid === userid)
  }

  onRemoveUser (userid: number) {
    this.selectedUsers = this.selectedUsers.filter((item: any) => item.userid !== userid)
  }

  getErrorMessage (error:any) {
    switch (error.message) {
      case 'users out of range':
        return '管理员人数已达上限，请删除部分后再添加'
      default:
        return '当前网络异常，请稍后重试'
    }
  }

  async submit () {
    try {
      const userids = this.selectedUsers.map((t: any) => t.userid)
      await addAdmin(userids, this.curEnterprise.developer_id)
      this.onOk(this.selectedUsers)
    } catch (e) {
      onRequestError(e, this.getErrorMessage(e))
    }
  }
}
